import ScheduleMonthCalendar from './ScheduleMonthCalendar';

export default ScheduleMonthCalendar;
